<template lang="html">
  <div class="card" :style="selfStyle">
    <div class="card-body">
      <!-- <div class="card-header">
        置顶
      </div> -->
      <Stick v-for="item in datas" :key="item.nid" :item="item"/>
    </div>
    <Loading :loading="false"/>
  </div>
</template>

<script>
import Stick from '../components/Stick.vue'
import Loading from './Loading.vue'
import { get } from '../utils/request'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('communication')
const Refresh = createNamespacedHelpers('refresh')
export default {
  props: [
    'selfStyle'
  ],
  components: {
    Stick,
    Loading
  },
  data () {
    return {
      datas: [],
      loading: false,
      total: 0,
      page: 1,
      sizes: [10, 20, 30, 40, 50, 100],
      size: 10
    }
  },
  mounted () {
    this.getCategoryArticle()
  },
  computed: {
    getCategoryId () {
      return this.getTag()
    },
    ...Refresh.mapGetters({
      getDownRefresh: 'getDownRefresh'
    })
  },
  methods: {
    ...mapGetters([
      'getTag'
    ]),
    getCategoryArticle () {
      this.loading = true
      const promise = get({
        url: `/bbs/getCategoryArticle/${this.getTag()}?page=${this.page}&size=${this.size}`
      })
      promise.then(res => {
        const { status, data: { count, results } } = res
        if (Object.is(status, 200)) {
          this.datas = results
          this.total = count
        }
        this.loading = false
      })
    },
    changePage (page) {
      this.page = page
      this.getCategoryArticle()
    },
    changeSize (size) {
      this.size = size
      this.getCategoryArticle()
    }
  },
  watch: {
    /* eslint-dsiable-next-line */
    getCategoryId (value) {
      this.page = 1
      this.getCategoryArticle()
    },
    getDownRefresh (value) {
      if (!value) {
        this.getCategoryArticle()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/font/iconfont.css';
.label {
  height: 16px;
  line-height: 16px;
  padding: 0 5px;
  margin-right: 10px;
  font-size: 12px;
  border: 1px solid #FF5722;
  background: none;
  color: #FF5722;
}
.card {
  box-sizing: border-box;
  width: 100%;
  padding: 0 7.5px;
  border-radius: 2px;
  background: transparent;
  margin-bottom: 15px;
  .card-body {
    background-color: #fff;
    .card-header {
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      border-bottom: 1px dotted #E9E9E9;
      color: #333;
      border-radius: 2px 2px 0 0;
      font-size: 14px;
    }
  }
}
@media screen and (max-width: 768px) {
  .card {
    padding:0 7.5px !important;
  }
}
</style>
